import Quiz2List from "./Quiz2List";

export default Quiz2List;
